module.exports = __webpack_public_path__ + "static/media/flyer-wissen-in-bildern.b49b7db3.pdf";